import React from "react";
import parse from 'html-react-parser';
import './css/description-box.css'
import { Box, Skeleton, Divider, Stack, Button } from "@mui/material";

const DescriptionBox = ({ product, loading }) => {
    if (loading) {
        return (
            <Box sx={{ m: 4 }}>
                {/* Tabs skeleton */}
                <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
                    <Skeleton variant="rounded" width={120} height={40} />
                    <Skeleton variant="rounded" width={140} height={40} />
                </Stack>

                {/* Description skeleton */}
                <Box
                    sx={{
                        border: "1px solid #d0d0d0",
                        borderRadius: 1,
                        p: 3,
                        backgroundColor: "#fff",
                    }}
                >
                    <Skeleton variant="text" width="60%" height={28} sx={{ mb: 2 }} />
                    <Skeleton variant="text" width="90%" height={20} />
                    <Skeleton variant="text" width="95%" height={20} />
                    <Skeleton variant="text" width="80%" height={20} />
                </Box>
            </Box>
        );
    }

    return (
        <Box className="description-container">
            {/* Navigator Tabs */}
            <Stack direction="row" spacing={0}>
                <Button
                    variant="outlined"
                    sx={{
                        borderColor: "#d0d0d0",
                        borderRadius: 0,
                        fontWeight: 600,
                        textTransform: "none",
                        px: 3,
                        color: "#000",
                    }}
                >
                    Description
                </Button>
            </Stack>

            {/* Divider */}
            <Divider sx={{ borderColor: "#d0d0d0" }} />

            {/* Description Box */}
            <Box
                sx={{ lineHeight: 1.7, whiteSpace: "pre-line" }}
                className="description-html"
            >
                {product?.description ? parse(product.description) : "No description available."}
            </Box>
        </Box>
    );
};

export default DescriptionBox;